import { render, staticRenderFns } from "./schoolthree.vue?vue&type=template&id=6b106982&scoped=true"
import script from "./schoolthree.vue?vue&type=script&lang=js"
export * from "./schoolthree.vue?vue&type=script&lang=js"
import style0 from "./schoolthree.vue?vue&type=style&index=0&id=6b106982&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b106982",
  null
  
)

export default component.exports